import { ENV_DEV } from "../../../../utils/window";
import getParametersData from "./get-parameters-data";
import setTriggerPercentsPointer from "./set-trigger-percents-pointer";
import setTriggerPercentsScroll from "./set-trigger-percents-scroll";

/**
 * Set the function that computes the percents used on a coordinate-based trigger
 * @param {TriggerProps} trigger
 * @returns
 */
const setTriggerPercentsFn = (trigger) => {
  const coordinates = trigger.get("is-coordinates-based");

  if (!coordinates) {
    trigger.set("get-percents", null);
    return;
  }

  let fn = null;

  const pMethod = /** @type {PropertyValueProps} */ (trigger.get("p_method"));
  const methodData = getParametersData(pMethod);
  const method = /** @type {String} */ (methodData.get("name"));

  if (trigger.get("scroll")) {
    fn = setTriggerPercentsScroll(method);
  }

  if (trigger.get("pointer")) {
    fn = setTriggerPercentsPointer(method);
  }

  if (ENV_DEV && !fn) {
    console.error(
      `[TorusKit error]: Unknown parameter \`method\` parameter: \`${method}\``
    );
  }

  trigger.set("get-percents", fn);
  trigger.set("p_method-data", methodData);
};

export default setTriggerPercentsFn;
